import { render, staticRenderFns } from "./addgridother.vue?vue&type=template&id=4bf8dea8&scoped=true&"
import script from "./addgridother.vue?vue&type=script&lang=js&"
export * from "./addgridother.vue?vue&type=script&lang=js&"
import style0 from "./addgridother.vue?vue&type=style&index=0&id=4bf8dea8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf8dea8",
  null
  
)

export default component.exports